import VeeValidate, {Validator} from 'vee-validate'
import token_conf from './token_conf.js'

export default {
  langArr:{cn:{'id':1,'title':'zh_CN'},en:{'id':2,'title':'en'},tw:{'id':9,'title':'zh_TW'}},
  Vue:'',
  getLang(flang){
    let lang = flang ? flang : token_conf.get('tokenlang')
    const f_lang = new URLSearchParams(window.location.search).get('user_lang');
    if(f_lang == 1){
      lang = 'cn'
    }else if(f_lang == 2){
      lang = 'en'
    }else if(f_lang == 9){
      lang = 'tw'
    }
    console.log(44,lang)
    if(!lang){
      if(/zh-/i.test(navigator.language) || /zh/i.test(navigator.language)){
        lang = 'cn'
      }
      else if(/en/i.test(navigator.language)){
        lang = 'en'
      }else if(/fr/i.test(navigator.language)){
        lang = 'fr'
      }
      if(this.isSearchEngineVisitor()){
        lang = 'cn'//设置浏览器识别语言都是中文
      }
    }else{
       for (var i in this.langArr) {
            if(this.langArr[i].id == lang){
              lang = i
            }
        }
    }
    if(!this.langArr[lang]){
        if(this.langArr['en']){
            lang = 'en'
        }else{
            lang = Object.keys(this.langArr)[0]
        }
    }
    token_conf.set('tokenlang',this.langArr[lang].id)
    return lang
  },
  initLang(Vue){
    this.Vue = Vue
    this.setLang()
  },
  setLang(flang,data){

    let nowLocale = this.getLang(flang)
    data = data ? data : {}
    let nowLocalef = nowLocale == 'cn' ? 'zh-CN' : nowLocale
    document.querySelector('#vux_view_box_html').lang = nowLocalef
    this.Vue.i18n.add(nowLocalef, Object.assign(require('./lang/'+nowLocalef+'.json'), data))
    this.Vue.i18n.set(nowLocalef)
    Validator.localize(this.langArr[nowLocale].title,
        require('vee-validate/dist/locale/'+this.langArr[nowLocale].title)
    )
    Validator.extend('minlength', {
        getMessage: (field, params, data) => {
            return field + '最少选择 '+params[0]+' 个';
          },
        validate: (value, args) => {
           return value.length >= args[0]
        }
    });

    Validator.extend('maxlength', {
        getMessage: (field, params, data) => {
            return field + '最多选择 '+params[0]+' 个';
          },
        validate: (value, args) => {
           return value.length <= args[0]
        }
    });
    let config = {
        errorBagName: 'ers',
        delay: 100,
        messages: null,
        strict: true,
    };
    this.Vue.use(VeeValidate,config)
  },
  isSearchEngineVisitor() {
    let userAgent = navigator.userAgent.toLowerCase();
    let searchEngines = [
      'googlebot',    // Google
      'bingbot',      // Bing
      'slurp',        // Yahoo
      'duckduckbot',  // DuckDuckGo
      'baiduspider',  // Baidu
      'yandexbot',    // Yandex
      'sogou',        // Sogou
      'exabot',       // Exalead
      'facebot',      // Facebook
      'ia_archiver'   // Alexa
    ];
    // 判断是否为搜索引擎
    return searchEngines.some(engine => userAgent.includes(engine));
  }
};